import React from 'react';
import "./thousandsHyaia.scss";

//images
import imgthousandsHyaia from "../../../assets/connectors/thousandsHyaia.png";
import { useTranslation } from 'react-i18next';

const ThousandsHyaia = () => {
    const {t} = useTranslation()

    return (
        <div className="container-thousandsHyaia">
            <div className="img-thousandsHyaia">
                <img src={imgthousandsHyaia} alt="" />
            </div>
            <div className="texts-thousandsHyaia">
                <h1>{t("connectors.thousands.title")}</h1>
                <p>{t("connectors.thousands.section_text")}</p>
            </div>
        </div>
    )
}

export default ThousandsHyaia;